<div class="map-container">
    <google-map
        height="100%"
        width="100%"
        [zoom]="14"
        [center]="{ lat: latitude, lng: longitude }"
        [options]="{
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true
            }"
        >
        <map-marker *ngIf="latitude && longitude" [position]="{ lat: latitude, lng: longitude }"></map-marker>
    </google-map>

    <div id="streetview-small" [class.hide]="!isStreetViewVisible" #streetviewSmall>
        <div class="text">{{'NO_STREET_VIEW_AVAILABLE' | translate}}</div>
        <div (click)="isStreetViewVisible = false" class="x-container"><img src="../../../assets/icons/close.svg" alt="Close icon" /></div>
    </div>
</div>

